import { bool, shape, string } from 'prop-types';
import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { CONTENT_TYPE_ROUTES } from 'constants/content';
import { HISTORY } from 'constants/proptypes';
import Document from 'containers/Document';
import { selectors as authSelectors } from 'modules/auth';

const Details = ({ history, isLoggedIn, match }) => {
    const { type } = match.params;
    const hideSummary = type === CONTENT_TYPE_ROUTES.QUESTION_AND_ANSWER;

    const onLoadFailure = () => {
        history.replace('/public/content/invalid');
    };

    useEffect(() => {
        if (isLoggedIn) {
            if (history.location.pathname.includes('/featured-content')) {
                history.replace(
                    history.location.pathname.split('/public/content/details/featured-content')[1]
                );
            } else {
                history.replace(history.location.pathname.split('/public/content/details')[1]);
            }
        }
    });
    return <Document hideSummary={hideSummary} onLoadFailure={onLoadFailure} />;
};

Details.propTypes = {
    history: HISTORY.isRequired,
    isLoggedIn: bool,
    match: shape({
        params: shape({
            type: string.isRequired,
        }).isRequired,
    }).isRequired,
};

Details.defaultProps = {
    isLoggedIn: false,
};

const mapStateToProps = createStructuredSelector({
    isLoggedIn: authSelectors.isUserLoggedIn,
});

export { Details as DetailsUnwrapped };
export default connect(mapStateToProps)(Details);
